module.exports = __webpack_public_path__ + "img/sleeping-face.0d9f53c8.png";